/*
 * @Author: Zhouqi
 * @Date: 2026-03-26 12:50:48
 * @LastEditors: Zhouqi
 * @LastEditTime: 2026-03-26 18:02:34
 */
// 营销活动类型
export enum CampaignType {
  FIRST_ORDER = 'first_order',
  DISTRIBUTION = 'distribution',
  NONE = 'none',
}

// 优惠券类型
export enum CouponType {
  DISTRIBUTION_ALL = 'distribution_all',
  DISTRIBUTION_SPECIFIC = 'distribution_specific',
  NEW_USER_EXCLUSIVE = 1,
  NORMAL_COUPON = 'normal_coupon',
  NONE = 'none',
}

// 标准化优惠券
export interface StandardCoupon {
  type: CouponType;
  priority: number;
  discount?: number;
  commodityCodes: string[];
  leftSeconds?: number;
  pattern?: number;
  rawData: any;
}

// 策略上下文
export interface StrategyContext {
  showTopTip?: boolean;
}

// 营销策略接口
export interface MarketingStrategy {
  type: CampaignType;
  priority: number;
  canActivate: () => boolean | Promise<boolean>;
  show: (context?: StrategyContext) => void | Promise<void>;
}
